import script from "./overview.vue?vue&type=script&lang=ts&setup=true"
export * from "./overview.vue?vue&type=script&lang=ts&setup=true"

import "./overview.vue?vue&type=style&index=0&id=4a5b93d8&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a5b93d8"]])

export default __exports__